import { __assign } from "tslib";
import { NEW_PRESETS, utils } from 'pro-gallery-lib';
import { formatLeanGalleryStyles } from './leanGallery';
import { handledStyleParams, fixedStyleParams } from './consts';
//example: http://pro-gallery.surge.sh/?titlePlacement=DONT_SHOW&itemClick=nothing&allowHover=false&galleryLayout=2&allowLeanGallery=true
var MAX_ITEMS_COUNT = 25;
export default (function (_a) {
    var items = _a.items, styles = _a.styles, _b = _a.totalItemsCount, totalItemsCount = _b === void 0 ? 0 : _b;
    styles = formatLeanGalleryStyles(styles);
    var allowLeanGallery = !!styles.allowLeanGallery;
    if (!allowLeanGallery) {
        return false;
    }
    if (totalItemsCount > items.length) {
        utils.isVerbose() &&
            console.log("[LEAN GALLERY] NOT ALLOWED - not all items arrived", totalItemsCount, items.length);
        return false;
    }
    var totalItems = Math.max(items.length, totalItemsCount);
    if (totalItems > MAX_ITEMS_COUNT) {
        utils.isVerbose() &&
            console.log("[LEAN GALLERY] NOT ALLOWED - more than " + MAX_ITEMS_COUNT + " items", totalItems);
        return false;
    }
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        if (!isImage(item)) {
            utils.isVerbose() &&
                console.log("[LEAN GALLERY] NOT ALLOWED - an item that is not an image", item);
            return false;
        }
    }
    for (var _c = 0, _d = Object.entries(styles); _c < _d.length; _c++) {
        var _e = _d[_c], styleParam = _e[0], value = _e[1];
        if (!isValidStyleParam(styleParam, value, styles)) {
            utils.isVerbose() &&
                console.log("[LEAN GALLERY] NOT ALLOWED - invalid styleParam", styleParam, value);
            return false;
        }
    }
    utils.isVerbose() && console.log("[LEAN GALLERY] ALLOWED!", styles);
    return true;
});
export var notEligibleReasons = function (_a) {
    var items = _a.items, styles = _a.styles;
    var s = __assign(__assign(__assign({}, styles), NEW_PRESETS.grid), { allowLeanGallery: true });
    var res = [];
    if (String(styles.galleryLayout) !== '2') {
        res.push('not a Grid layout');
    }
    if (items.length > MAX_ITEMS_COUNT) {
        res.push("more than " + MAX_ITEMS_COUNT + " items");
    }
    var nonImagesCount = 0;
    for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
        var item = items_2[_i];
        if (!isImage(item)) {
            nonImagesCount++;
        }
    }
    if (nonImagesCount > 0) {
        res.push(nonImagesCount + " items are not an image");
    }
    for (var _b = 0, _c = Object.entries(s); _b < _c.length; _b++) {
        var _d = _c[_b], styleParam = _d[0], value = _d[1];
        if (!isValidStyleParam(styleParam, value, s)) {
            res.push("invalid style: " + styleParam + " => " + value);
        }
    }
    return res;
};
//#region Helper Functions
var isImage = function (item) {
    var meta = item.metadata || item.metaData;
    var isImageItem = !!((!meta.type || meta.type === 'image') &&
        (item.url || item.mediaUrl || item.src));
    return isImageItem;
};
var isValidStyleParam = function (styleParam, value, allStyles) {
    if (typeof handledStyleParams[styleParam] !== 'undefined')
        return true;
    // if (typeof ignoredStyleParams[styleParam] !== 'undefined') return true;
    if (typeof fixedStyleParams[styleParam] !== 'undefined') {
        var sp = fixedStyleParams[styleParam];
        if (sp && typeof sp === 'function') {
            return sp(allStyles);
        }
        else if (sp && sp.length > 0) {
            return sp.includes(value);
        }
        else {
            return sp === value;
        }
    }
    return true;
};
//#endregion
//# sourceMappingURL=isEligible.js.map